import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../context/authConfig";
import Button from "react-bootstrap/Button";
import '../styles/landing.css';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (

        <Button className="sign-in-btn" onClick={() => handleLogin("redirect")} name="Sign in">Sign In</Button>
    )
}